module.exports = __webpack_public_path__ + "static/media/friendship.b229e6c3.svg";